import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withVDSManager } from '@vds-core/utilities';
import { TypographyTokens } from '@vds-tokens/typography';
import { ColorTokens } from '@vds-tokens/color';
import { Fonts } from '../../fonts';
import { Typography } from '../Typography';
var propTypes = {
  /**
   * Primitive used for the component.
   */
  primitive: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'span', 'p']),
  /**
   * Viewport the font styling is based on. Desktop and tablet are the same size.
   */
  viewport: PropTypes.oneOf(['desktop', 'tablet', 'mobile']),
  /**
   * Size of the typescale that will be used.
   */
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  /**
   * Content that will be passed to the component.
   */
  children: PropTypes.node,
  /**
   * @ignore
   * The color of the text.
   */
  color: PropTypes.oneOf(['#000000', '#FFFFFF', '#ffffff', '#EE0000', '#ee0000', '#F6F6F6', '#f6f6f6', '#D8DADA', '#d8dada', '#A7A7A7', '#a7a7a7', '#6F7171', '#6f7171', '#333333', '#1B1D1F', '#1b1d1f', '#FBE4D7', '#fbe4d7', '#ED7000', '#ed7000', '#C44904', '#c44904', '#4A1C02', '#4a1c02', '#FFF4E0', '#fff4e0', '#FFBC3D', '#ffbc3d', '#523C14', '#523c14', '#D6EEFB', '#d6eefb', '#0096E4', '#0096e4', '#0077B4', '#0077b4', '#002B42', '#002b42', '#D6F2E0', '#d6f2e0', '#00AC3E', '#00ac3e', '#008330', '#003614', '#747676' // BRand1.0 Coolgray6
  ]),
  /**
   * Adds a fontWeight of bold.
   */
  bold: PropTypes.bool,
  /**
   * Adds a text decoration of line through.
   */
  strikethrough: PropTypes.bool,
  /**
   * The tabIndex of the text.
   */
  tabIndex: PropTypes.number,
  /**
   * Assigns an Id to the component
   */
  id: PropTypes.string,
  /**
   * Assigns an testid to the component
   */
  'data-testid': PropTypes.string,
  /**
   * Adds an aria-labelledby attribute to the component
   */
  ariaLabelledBy: PropTypes.string,
  /**
   * @ignore
   */
  letterSpacing: PropTypes.string,
  /**
   * @ignore
   */
  lineHeight: PropTypes.string
};
var defaultProps = {
  primitive: 'p',
  viewport: 'desktop',
  size: 'small',
  children: null,
  color: ColorTokens.palette.black.value,
  bold: false,
  strikethrough: false,
  lineHeight: null,
  letterSpacing: null
};
var StyledBody = /*#__PURE__*/styled(Typography).withConfig({
  displayName: "StyledBody",
  componentId: "VDS__sc-1s1yqd8-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  &:active,\n  &:focus,\n  &:hover {\n    outline: none;\n  }\n"])), function (_ref) {
  var strikethrough = _ref.strikethrough,
    bold = _ref.bold,
    size = _ref.size;
  return strikethrough && (size === 'medium' || !bold) && 'text-decoration: line-through';
});
var Body = function Body(props) {
  var children = props.children,
    primitive = props.primitive,
    viewport = props.viewport,
    size = props.size,
    color = props.color,
    bold = props.bold,
    tabIndex = props.tabIndex,
    ariaLabel = props.ariaLabel,
    strikethrough = props.strikethrough,
    id = props.id,
    ariaLabelledBy = props.ariaLabelledBy,
    fontFamily = props.fontFamily,
    testId = props['data-testid'];
  var viewportToUse = viewport === 'mobile' ? 'mobile' : 'desktop';
  var fontSizeToUse = ['small', 'medium', 'large'].indexOf(size) > -1 ? size : 'small';
  var fontSizeValue = function fontSizeValue() {
    switch (fontSizeToUse) {
      case 'large':
        return 16;
      case 'medium':
        return 14;
      case 'small':
      default:
        return 12;
    }
  };
  var lineHeightValue = function lineHeightValue() {
    switch (fontSizeToUse) {
      case 'large':
        return 20;
      case 'medium':
        return 18;
      case 'small':
      default:
        return 16;
    }
  };
  var fontWeight = bold ? TypographyTokens.fontweight.bold.value : TypographyTokens.fontweight.regular.value;
  var letterspacing = fontSizeToUse === 'small' ? undefined : TypographyTokens.letterspacing.wide.value; // 0.5px

  return /*#__PURE__*/React.createElement(StyledBody, {
    fontSize: TypographyTokens.fontsize.body[fontSizeValue()].value,
    fontWeight: fontWeight,
    fontFamily: fontSizeToUse === 'small' ? Fonts.VerizonNHGeTX : Fonts.VerizonNHGeDS,
    lineheight: TypographyTokens.lineheight.body[lineHeightValue()].value,
    letterSpacing: letterspacing,
    bold: bold,
    primitive: primitive,
    color: color,
    strikethrough: strikethrough,
    size: size,
    id: id,
    "aria-labelledby": ariaLabelledBy,
    "aria-label": ariaLabel,
    tabIndex: tabIndex,
    "aria-hidden": tabIndex < 0,
    "data-testid": testId
  }, children);
};
Body.propTypes = propTypes;
Body.defaultProps = defaultProps;
export default withVDSManager(Body);